<template>
  <div>
    <b-alert show variant="warning" v-if="selectedLea.type != 3">
      Statewide Report is only available at State Level. Please select an appropriate LEA from the LEA Context Picker above.
    </b-alert>
    <div v-else>
      <excel-button title="Statewide Report" style="z-index: 1000;" />
      <filter-widget @apply-filter="updateFilter($event)" class="mb-2" :ay="ay" :ay-options="ayOptions" />
      <b-alert show variant="info" v-if="selectedLea.type > 2">
        Percent of each of the following measures that have been met by the 12th grade:
        <ul>
          <li>Industry Recognized Credentials</li>
          <li>Work-Based Learning</li>
          <li>Financial Aid</li>
          <li>Post-Secondary Placement</li>
        </ul>
      </b-alert>
      <Promised :promise="loadData" v-show="loadData">
        <template v-slot:pending>
          <div class="align-items-center justify-content-center loading-card" style="height: 100%; width: 100%">
            <card-state-icon icon-class="fa-4x fas fa-spinner fa-spin text-secondary" message="Loading..." />
          </div>
        </template>
        <template v-slot:rejected="error" class="align-items-center justify-content-center">
          <card-state-icon icon-class="fa-4x fas fa-exclamation-triangle text-danger" :message="'Error: ' + error.message" />
        </template>      
        <template v-slot>
          <div v-if="reportData && reportData" class="report-output">
            <student-list :items="reportData" :fields="fields" />
          </div>
        </template>
      </Promised>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import FilterWidget from './FilterWidget.vue'
import StudentList from './StudentList.vue'
import CardStateIcon from '@/components/CardStateIcon'
import ExcelButton from '@/components/ExcelButton'
import { Promised } from 'vue-promised'
import { mapState } from 'vuex'
import { mapFieldsToExcel } from '@/helpers/tableHelpers'
import { AYDependentReportMixin } from '../AYDependentReportMixin'

export default {
  components: {
    FilterWidget,
    StudentList,
    Promised,
    CardStateIcon,
    ExcelButton,
  },
  data() {
    return {
      filter: {
        academicYear: null,
        lea: null
      },
      loadData: null,
      reportData: null,
      fields: [
        { key: 'districtLEA', label: 'District LEA' },
        { key: 'percentIndustryRecognizedCredentials', label: 'Percent Industry Recognized Credentials', formatter: v => v != null ? (v * 100).toFixed(1) + '%' : '' },
        { key: 'percentWorkBasedLearning', label: 'Percent Work-Based Learning', formatter: v => v != null ? (v * 100).toFixed(1) + '%' : '' },
        { key: 'percentFinancialAid', label: 'Percent Financial Aid', formatter: v => v != null ? (v * 100).toFixed(1) + '%' : '' },
        { key: 'percentPostSecondaryPlacement', label: 'Percent Post-Secondary Placement', formatter: v => v != null ? (v * 100).toFixed(1) + '%' : '' },
        { key: 'averageActScore', label: 'Average ACT Score' },
        { key: 'totalStudents', label: '12th Grade Roster Total' }
      ]
    }
  },
  computed: {
    ...mapState('cte/careercoach/reporting', ['rosterDates']),
  },
  methods: {
    updateFilter(filter) {
      this.filter.lea = this.selectedLea.number

      Object.keys(filter).forEach(key => {
        Vue.set(this.filter, key, filter[key])
      });

      this.getData()
    },
    getData() {
      this.loadData = this.$store.dispatch('cte/careercoach/reporting/statewideReport', { lea: 'AR', ay: this.filter.academicYear })
        .then(d => {
          this.reportData = d
        })
    },
    excelExportData() {
      let fields = [...this.fields]
      fields.splice(1, 0, { label: 'District Name', formatter: (v, k, item) => this.leaDictionary[item.districtLEA].name })
      return {
        name: 'Statewide Report',
        items: [...mapFieldsToExcel(this.reportData, [...fields])]
      }
    }
  },
  watch: {
    selectedLea: {
      immediate: false,
      handler() {
        this.filter.lea = this.selectedLea.number
      }
    },
    filter: {
      deep: true,
      handler() {
        this.getData()
      }
    }
  },
  mixins: [
    AYDependentReportMixin 
  ]
}
</script>